import { DrawerOverlay as ChakraDrawerOverlay } from '@chakra-ui/react'

import { DrawerOverlayProps } from './DrawerOverlay.types'

export default function Drawer(props: DrawerOverlayProps) {
  return <ChakraDrawerOverlay {...props} translate="no" />
}
